<script>
	import request from './request.vue';
	import { format } from "date-fns";

	const categorySchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código da categoria",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "userId",
			displayName: "Usuário",
			kind: "text",
			validation: "",
			readOnly: true,
		},
		{
			name: "pageName",
			displayName: "Página",
			kind: "text",
			validation: "required",
			formatter: value => (value || "Contato"),
			placeholder: "Digite o nome da página",
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "platform",
			displayName: "Plataforma",
			kind: "select",
			validation: "",
			placeholder: "",
			readOnly: true,
			formatter: value => value ? value : "WEB",
			options: [
				{
					name: "WEB",
					value: "WEB",
				},
				{
					name: "APP",
					value: "APP",
				}
			],
			search: {
				show: true,
			}
		},
		{
			name: "creationDate",
			displayName: "Data",
			kind: "text",
			validation: "",
			placeholder: "DD/MM/AAAA",
			readOnly: true,
			formatter: value => format(new Date(value).toLocaleString("en-US", {timeZone: "America/sao_paulo"}), "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			defaultSort: true,
			notInFilters: true,
			search: {
				show: true,
			},
		},
		{
			name: "comment",
			displayName: "Comentário",
			kind: "long-text",
			validation: "",
			placeholder: "Escreve o comentário",
		},
	];

	export default {
		getInfo: async function (id) {
			const response = await request.send("contact", "read", { id }, true);
			return response.data;
		},
		search: async function(parameters) {
			const response = await request.send("contact", "search", parameters, true);
			return response;
		},
		getSchema: function() {
			return categorySchema;
		},
	}
</script>
